/**
 * @generated SignedSource<<94f2aec399ba621b95a54d1a9a1fe835>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AdminMembersReportProductsTabStatisticsCardsQuery$variables = {
  id: string;
  startDate?: string | null;
};
export type AdminMembersReportProductsTabStatisticsCardsQuery$data = {
  readonly node: {
    readonly __typename: "OrganizationMembership";
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"MemberReportProductEventsAttendanceRateStatisticCardFragment" | "MemberReportProductsRegisteredStatisticCardFragment" | "MemberReportTimeSpentOnCurriculumStatisticCardFragment">;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null;
};
export type AdminMembersReportProductsTabStatisticsCardsQuery = {
  response: AdminMembersReportProductsTabStatisticsCardsQuery$data;
  variables: AdminMembersReportProductsTabStatisticsCardsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "startDate"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "kind": "Variable",
  "name": "startDate",
  "variableName": "startDate"
},
v5 = [
  (v4/*: any*/)
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "allTime",
  "storageKey": null
},
v7 = [
  (v6/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AdminMembersReportProductsTabStatisticsCardsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              {
                "args": (v5/*: any*/),
                "kind": "FragmentSpread",
                "name": "MemberReportProductsRegisteredStatisticCardFragment"
              },
              {
                "args": (v5/*: any*/),
                "kind": "FragmentSpread",
                "name": "MemberReportTimeSpentOnCurriculumStatisticCardFragment"
              },
              {
                "args": (v5/*: any*/),
                "kind": "FragmentSpread",
                "name": "MemberReportProductEventsAttendanceRateStatisticCardFragment"
              }
            ],
            "type": "OrganizationMembership",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AdminMembersReportProductsTabStatisticsCardsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": (v5/*: any*/),
                "concreteType": "GenericReportingResponse",
                "kind": "LinkedField",
                "name": "productsRegisteredReport",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "sinceYesterday",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v5/*: any*/),
                "concreteType": "GenericReportingResponse",
                "kind": "LinkedField",
                "name": "timeSpentOnCurriculumSecondsReport",
                "plural": false,
                "selections": (v7/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "productLevel",
                    "value": true
                  },
                  (v4/*: any*/)
                ],
                "concreteType": "GenericReportingResponse",
                "kind": "LinkedField",
                "name": "eventsAttendanceRateReport",
                "plural": false,
                "selections": (v7/*: any*/),
                "storageKey": null
              }
            ],
            "type": "OrganizationMembership",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a0cf9e83fe08cf9287b2c9b7641caffd",
    "id": null,
    "metadata": {},
    "name": "AdminMembersReportProductsTabStatisticsCardsQuery",
    "operationKind": "query",
    "text": "query AdminMembersReportProductsTabStatisticsCardsQuery(\n  $id: ID!\n  $startDate: String\n) {\n  node(id: $id) {\n    __typename\n    ... on OrganizationMembership {\n      id\n      ...MemberReportProductsRegisteredStatisticCardFragment_4sOHZa\n      ...MemberReportTimeSpentOnCurriculumStatisticCardFragment_4sOHZa\n      ...MemberReportProductEventsAttendanceRateStatisticCardFragment_4sOHZa\n    }\n    id\n  }\n}\n\nfragment MemberReportProductEventsAttendanceRateStatisticCardFragment_4sOHZa on OrganizationMembership {\n  eventsAttendanceRateReport(startDate: $startDate, productLevel: true) {\n    allTime\n  }\n}\n\nfragment MemberReportProductsRegisteredStatisticCardFragment_4sOHZa on OrganizationMembership {\n  productsRegisteredReport(startDate: $startDate) {\n    allTime\n    sinceYesterday\n  }\n}\n\nfragment MemberReportTimeSpentOnCurriculumStatisticCardFragment_4sOHZa on OrganizationMembership {\n  timeSpentOnCurriculumSecondsReport(startDate: $startDate) {\n    allTime\n  }\n}\n"
  }
};
})();

(node as any).hash = "73b85c9fb169e2bda22292f74155fcf6";

export default node;
